module.exports = __webpack_public_path__ + "src/assets/img/graph-ico.a4922911.png";